import { CellContext, ColumnDef, Row } from '@tanstack/react-table'
import * as React from 'react'
import {
  NameCell,
  DescriptionCell,
  ProficiencyCell,
  ActionsCell,
} from './cells'

export type UserPersonalSkillsTableRow = {
  id: string
  profileSkillId: string
  name: string
  description: string | null
  skillType: string | null
  proficiencyLevel: number | null
  source: 'implied' | 'assigned' | 'self_declared'
  starred: boolean
}

const sourceFilterFn = (
  row: Row<UserPersonalSkillsTableRow>,
  columnId: string,
  filterValue: string | string[]
) => {
  const value = row.getValue(columnId) as string
  if (Array.isArray(filterValue)) {
    return filterValue.includes(value)
  }
  return value === filterValue
}

export class Data {
  get columns() {
    return [
      {
        accessorKey: 'name',
        cell: NameCell,
        enableGlobalFilter: true,
        header: 'Name',
        id: 'name',
        size: 280,
        minSize: 200,
      },
      {
        accessorKey: 'skillType',
        cell: this.renderSkillType,
        enableGlobalFilter: false,
        header: 'Skill type',
        id: 'skillType',
        filterFn: 'equals',
        size: 120,
      },
      {
        accessorKey: 'description',
        cell: DescriptionCell,
        enableGlobalFilter: true,
        header: 'Description',
        id: 'description',
        size: 300,
        minSize: 200,
      },
      {
        accessorKey: 'proficiencyLevel',
        cell: ProficiencyCell,
        enableGlobalFilter: false,
        header: 'Proficiency',
        id: 'proficiencyLevel',
        sortingFn: 'alphanumeric',
        size: 140,
      },
      {
        accessorKey: 'source',
        enableGlobalFilter: false,
        id: 'source',
        filterFn: sourceFilterFn,
        // Hidden column - only used for filtering
        size: 0,
      },
      {
        id: 'actions',
        enableGlobalFilter: false,
        cell: ActionsCell,
        size: 60,
      },
    ] satisfies ColumnDef<UserPersonalSkillsTableRow, never>[]
  }

  private renderSkillType(
    row: CellContext<UserPersonalSkillsTableRow, string | null>
  ) {
    const skillType = row.getValue()
    if (!skillType) return <span className="text-gray-400">-</span>
    const label =
      skillType.charAt(0).toUpperCase() + skillType.slice(1) + ' skill'
    return <span className="text-gray-600 text-sm">{label}</span>
  }
}
